import React from "react";
import { cn } from "@lib/utils";

interface StepperProps {
  steps: string[];
  currentStep: number;
  onStepClick: (step: number) => void;
}

export function Stepper({ steps, currentStep, onStepClick }: StepperProps) {
  return (
    <div className="relative flex items-center justify-between my-4 sm:my-8 overflow-hidden px-2 sm:px-0">
      {steps.map((step, index) => (
        <React.Fragment key={step}>
          <button
            className="flex flex-col items-center relative touch-manipulation min-w-[32px] sm:min-w-0"
            onClick={() => onStepClick(index + 1)}
            aria-label={`Step ${step}`}
          >
            <div
              className={cn(
                `p-1.5 sm:p-2 bg-primary/60 rounded-full transition-colors`,
                index + 1 < currentStep ? "bg-primary" : "bg-primary/60"
              )}
            >
              <div
                className={cn(
                  "w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-colors",
                  index + 1 < currentStep
                    ? "bg-primary"
                    : index + 1 === currentStep
                      ? "bg-primary"
                      : "bg-background"
                )}
              />
            </div>
          </button>
          {index < steps.length - 1 && (
            <div
              className={cn(
                "flex-1 border border-dashed border-primary mx-1 sm:mx-0"
              )}
            />
          )}
        </React.Fragment>
      ))}
      <div
        className={`inset-0 transform translate-x-(--inset-left) absolute h-full bg-linear-to-r from-background/0 to-background/80 pointer-events-none`}
        style={
          {
            "--inset-left": `${(currentStep / (steps.length - 1)) * 100}%`,
          } as React.CSSProperties
        }
      />
    </div>
  );
}
